import { AppType, BuildType, Environment } from '@domains';

export const environment: Environment = new Environment({
  app: AppType.DONOR,
  buildType: BuildType.DEMO,
  production: true,
});
